/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.24.0
 */

import { ReactElement } from 'react';

import { Typography } from '@nexign/scc-ui-kit';
import isFunction from 'lodash/isFunction';

import { LinkBlock } from '@/main/components/common';
import { openExternalRoute } from '@/main/routes/constants/externalRoutes';

import { IUserNotificationTranslation } from '../../internationalization/types';
import { INotificationsEntity } from '../types';
import { getNotificationContent } from './commonNotificationsUtils';

export const getCvmNotificationData = (
    entity: INotificationsEntity,
    translation: IUserNotificationTranslation,
    handleExternalNotification: (id: string | number) => void,
    isServiceUser: boolean,
    onLinkClick?: () => void,
): [ReactElement, ReactElement | undefined] => {
    const entityDef = getNotificationContent(entity);
    const content = <Typography isDangerousInnerHTML>{entityDef}</Typography>;

    const linkHref = entity.link ?? ''

    const handleLinkClick = () => {
        if (linkHref && entity.id) {
            if (!isServiceUser) handleExternalNotification(entity.id);
            openExternalRoute(linkHref, '_blank');
        }
        if (isFunction(onLinkClick)) onLinkClick();
    };

    const ItemLink =
        !!linkHref
            ? (
                <div>
                    <LinkBlock
                        isExternalUrl
                        withArrow
                        target={'_blank'}
                        url={linkHref}
                        onClick={handleLinkClick}
                    >
                        {translation.linkText.cvm}
                    </LinkBlock>
                </div>
            )
            : undefined;

    return [content, ItemLink];
};
